<!-- Customer Site Layout (Common for each page) -->
<app-site-header></app-site-header>
<router-outlet></router-outlet>

<app-site-footer></app-site-footer>